import { Component, OnInit } from '@angular/core';
import { CommonService } from '../common-service';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { WebSocketService } from '../websocket.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit{
  loginForm!: NgForm;
  email:any = ''
  userpassword:any = ''
  showPassword=true
  loader = true
  constructor(private api:CommonService,private router:Router,
    private messageService: MessageService,private webSocketService: WebSocketService){

  }
  ngOnInit(): void {
  }

  updatetrim(event:any,data:any){
    if (event.key === ' ') {
      // Prevent the default action of the space bar, which is to insert a space character
      event.preventDefault();
    }
  }

  submitLogin(){
    this.messageService.clear();
    let payload = {
        "usernameOrEmail": this.email,
        "password": this.userpassword.trim()
    }
    this.api.postMethod('get-user-token/v2',payload).subscribe({
      next:(data:any)=> {
        this.messageService.add({ severity: 'success', detail: data.message });
        let token = data.token
        localStorage.setItem("token",data.token)
        localStorage.setItem("username",data.username)
        localStorage.setItem("email",data.email)
        localStorage.setItem("role",data.role)
        localStorage.setItem("user_id",data.user_id)
        localStorage.removeItem('enableDataInsight');
        if(data.enableDataInsight === 1){
          localStorage.setItem("enableDataInsight", data.enableDataInsight)  
          this.router.navigate(['home'])        
        }       
        else{
          this.router.navigate(['get-answer']) 
        }
      },    
    error:(error:any)=>{
      this.messageService.add({ severity: 'error', detail: error.error.error});
    }
    })
   
  }
}
